import React, { useEffect, createElement } from 'react';
import { Article } from './components/Article';
export function App() {
  useEffect(() => {
    // Initialize Facebook Pixel
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      // Safety check: if no script elements exist, append to head instead
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // Initialize with your Pixel ID
    window.fbq('init', '1540823776588892');
    window.fbq('track', 'PageView');
    // Track ViewContent event
    window.fbq('track', 'ViewContent', {
      content_name: 'Thyroid Health Minerals Article',
      content_category: 'Health Information',
      content_type: 'article'
    });
    // Store fbclid in localStorage if present in URL
    const params = new URLSearchParams(window.location.search);
    const fbclid = params.get('fbclid');
    if (fbclid) {
      localStorage.setItem('fbclid', fbclid);
    }
  }, []);
  return <Article data-id="element-0" />;
}
// Declare fbq for TypeScript
declare global {
  interface Window {
    fbq: any;
  }
}